export const handleLogout = (navigate) => {
  localStorage.removeItem('access_token')
  sessionStorage.removeItem('access_token')
  localStorage.removeItem('sender_id')
  localStorage.removeItem('fullname')
  localStorage.removeItem('user_role')
  navigate('/signin')
}